export default "__VITE_ASSET__MXbLp5Sz__"